import React from 'react';
import { AnimatedHero } from './AnimatedHero';

interface HeroSectionProps {
  onGetStarted?: () => void;
  onWatchDemo?: () => void;
}

export const HeroSection: React.FC<HeroSectionProps> = ({
  onGetStarted,
  onWatchDemo,
}) => {
  return <AnimatedHero onGetStarted={onGetStarted} onWatchDemo={onWatchDemo} />;
};
